import React from 'react';
import { Redirect } from 'react-router-dom';
import { isMultiConfigProduct, isParentProduct } from '../../../utils/misc';
import useCurrentProduct from '../../../hooks/useCurrentProduct';
import { getProductLink } from '../shared/ProductLink';
import MultiConfig from './multi-config/MultiConfig';
import RegularProductConfig from './regular/RegularProductConfig';

// TODO: remove this componet when testing is complete

const ProductConfig = () => {
  const product = useCurrentProduct();

  if (!product) {
    return (
      <div>
        <h1>Product Config</h1>
        <p>Product not found</p>
      </div>
    );
  }

  // Must stay ahead of the parent check below: getProductLink sends a
  // multi-config parent BACK to /v3/products-regular/:id, so testing
  // isParentProduct first would redirect this route to itself forever.
  if (isMultiConfigProduct(product)) {
    return <MultiConfig product={product} />;
  }

  // In-app links send you-pick / build-your-own parents to their slot flow
  // (getProductLink), but a stale history entry, a refresh or an old link can
  // still land one here. RegularProductConfig would add the package to the
  // cart with no items chosen (ENG-1683), so leave for the slot flow instead.
  if (isParentProduct(product)) {
    return <Redirect to={getProductLink(product)} />;
  }

  // TODO: handle incentive and nth-free products here?

  return <RegularProductConfig product={product} />;
};

export default ProductConfig;
